import { Component } from "../components/components/component";

let nextScreenPrefixId = 1;

export function getNextScreenPrefixId(): number {
    return nextScreenPrefixId++;
}

export var SimpleScreen = function (options) {
    options = options || {};
    options.name = options.name || "Screen";
    this.id = getNextScreenPrefixId();

    // if (z.screens[options.name + this.id]) {
    //     throw "A screen with that name already exists, choose a different name";
    // }
    // z.screens[options.name + this.id] = this;

    this.name = options.name;
    this.screenId = this.id + "_" + options.name;

    this.container = $('<div id="' + this.screenId + '"></div>');
};

SimpleScreen.prototype = {
    attach: function (options) {
        options = options || {};
        options.mainDiv = options.mainDiv || $("#Main");
        options.mainDiv.append(this.container);
    },
    get: function (selector) {
        var me = this,
            container = null;
        if (selector.indexOf("#") > -1) {
            selector = selector.replaceAll("#", "#" + me.id + "_");
        } else if (selector.indexOf(".") == 0) {
            container = "#" + me.screenId;
        }

        var el = $(selector, container);
        return el;
    },
    destroy: function () {
        var me = this;

        var component = $(me.container.children()[0]).data("me") as Component;
        component.destroyComponent();
        me.destroyScreen && me.destroyScreen();
        $(me).trigger("closeScreen");

        var elements = $(me.container).find("*").addBack();
        $.each(elements, function (i, elem) {
            var element = $(elem),
                dataNames = Object.keys(element.data());

            $.each(dataNames, function (j, name) {
                if (name.substring(0, 5) == "kendo") {
                    var kendo = element.data(name);
                    if (kendo && kendo.destroy) {
                        kendo.destroy();
                        return false;
                    }
                }
                return true;
            });
        });

        // TODO: Call destroy on sub-components, popups, etc. -- Whatever needs it.
    }
};
